import styled from 'styled-components';
import { Theme } from '@/theme';

export const Title = styled.h3`
  font-family: ${Theme.font.family.speedeeCondensed};
  font-size: ${Theme.rems(40)};
  text-transform: uppercase;

  margin-bottom: 8px;
  text-align: center;
  line-height: 90%;
`;

export const Text = styled.p`
  font-size: ${Theme.rems(16)};
  margin-bottom: 16px;
  text-align: center;
  text-wrap: balance;
  line-height: 1.4;
`;
